module.exports = __webpack_public_path__ + "static/img/p1.efa5da6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1.jpg
// module id = zSkV
// module chunks = 1